import { boolToInt } from '../utils/boolToInt';

export const setFormBuilderPermissionFields = (field: unknown, key: string) => {
  const view = boolToInt(field[key].view);
  const edit = boolToInt(field[key].edit);
  return { view: [view], edit: [edit] };
};
